import React from 'react'
import { Layout, Menu, Icon } from 'antd'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { userAction } from '@store/user'
import HomeRoutes from '../../routes/home'
import style from './index.less'
import BasicMenu from './basic-menu'
import BasicBread from './basic-bread'

const { Header, Sider, Content } = Layout
const { SubMenu } = Menu

@connect(
  state => {
    return {
      // 获取key为user的对象中的key为user的值，即进行了两层嵌套
      user: state.getIn(['user', 'user'])
    }
  },
  dispatch => bindActionCreators(Object.assign({}, userAction), dispatch)
)
class Home extends React.Component {
  state = {
    collapsed: false
  }

  componentWillMount() {
    // 获取用户数据
    this.props.userGet()
    // 获取用户权限
    this.props.unreachableurlGet()
  }

  toggle = () => {
    const { collapsed } = this.state
    this.setState({
      collapsed: !collapsed
    })
  }

  loginOut = () => {
    window.location = `/internal/staff/loginout?callback=${encodeURIComponent(
      window.location.href
    )}`
  }

  render() {
    const { collapsed } = this.state
    const { user } = this.props
    return (
      <Layout style={{ height: '100%' }}>
        <Sider trigger={null} collapsible collapsed={collapsed}>
          <div className={style.logo}>{collapsed ? '' : '风控系统'}</div>
          <BasicMenu />
        </Sider>
        <Layout>
          <Header className={style.header}>
            <Icon
              className={style.trigger}
              type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
              onClick={this.toggle}
            />
            <Menu
              mode="horizontal"
              className={style['header-menu']}
              onClick={this.loginOut}
            >
              <SubMenu title={<span>Hi！{user.get('realName')}</span>}>
                <Menu.Item key="setting:1">
                  <Icon type="close-circle" theme="filled" /> 退出登录
                </Menu.Item>
              </SubMenu>
            </Menu>
          </Header>
          <Content style={{ padding: '0 8px 8px 8px' }}>
            <Layout className={style.layout} id="container">
              <BasicBread />
              <HomeRoutes />
            </Layout>
          </Content>
        </Layout>
      </Layout>
    )
  }
}

export default Home
